export const contingentCloseCircleIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 15"><path d="M5 10l5-5M10 10L5 5M7.5 14a6.5 6.5 0 100-13 6.5 6.5 0 000 13z" stroke="#E74C3C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'close-circle',
};
